// Shared wording for the warnings that some people can't use an agent's
// toolkits, so the share and project add-agent flows read the same.

// A large group would otherwise swamp the warning, so only the first few
// lacking members are named and the rest are counted.
const MAX_NAMED_MEMBERS = 3;

/** "Evals toolkit" or "Evals, Pipelines toolkits". */
export function toolkitPhrase(toolkitNames: string[]): string {
  return `${toolkitNames.join(", ")} ${toolkitNames.length > 1 ? "toolkits" : "toolkit"}`;
}

/** "a@x.com, b@x.com" or "a@x.com, b@x.com, c@x.com, +2 more". */
export function listMembers(emails: string[]): string {
  const named = emails.slice(0, MAX_NAMED_MEMBERS);
  const rest = emails.length - named.length;
  return rest > 0 ? [...named, `+${rest} more`].join(", ") : named.join(", ");
}

/** "2 of 5 members" / "1 of 1 member" — or "2 of 5 project members". */
export function memberCountPhrase(lacking: number, total: number, noun = "member"): string {
  return `${lacking} of ${total} ${noun}${total === 1 ? "" : "s"}`;
}
